import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Link, Typography } from '@mui/material';

function ContactSupport() {
  const { t } = useTranslation();
  const supportURI = useSelector((state) => state.content.supportURI);
  const showSupport = useSelector((state) => state.content.showSupport);

  if (!showSupport) return null;

  return (
    <Grid item>
      <Box display="flex" justifyContent="center" marginBottom="16px">
        <Link
          sx={(theme) => ({
            color: theme.palette.text.primary,
            cursor: 'pointer',
          })}
          href={supportURI}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('Contact support')}
        >
          <Typography fontSize={'small'} gutterBottom>
            <u>{t('Contact support')}</u>
          </Typography>
        </Link>
      </Box>
    </Grid>
  );
}

export default ContactSupport;
